import React, { useState } from 'react'
import { Button, Form } from 'react-bootstrap'
import _ from 'lodash'
import { useSelector } from 'react-redux'

import * as Constants from '../../../helpers/constants'
import showToastNotification from '../../widgets/toastify'
import { ApiHelper } from '../../../helpers/apihelper'
import ConfirmationModal from '../../../helpers/confirmationModal'

const initialState = {
  userId: '',
  errors: {}
}

const GlobalBfsSetting = ({ client }) => {
  const id = useSelector((state) => state.user.id)
  const userName = useSelector((state) => state.user.name)

  const [state, setState] = useState(initialState)
  const [showForm, setShowForm] = useState(false)
  const [showConfirmModal, setShowConfirmModal] = useState(false)
  const [confirmAction, setConfirmAction] = useState(null) // 'launch' | 'post'

  const showUserForm = () => {
    setShowForm(true)
  }

  const handleUserIdChange = (e) => {
    const userId = e.target.value
    setState((prev) => ({ ...prev, userId }))
  }

  // --- Open confirmation modal for BFS Launch ---
  const handleBfsLaunch = () => {
    setConfirmAction('launch')
    setShowConfirmModal(true)
  }

  // --- Open confirmation modal for Post BFS ---
  const handlePostBFS = () => {
    setConfirmAction('post')
    setShowConfirmModal(true)
  }

  // --- Actual API call logic executed after user confirms ---
  const handleConfirmAction = () => {
    setShowConfirmModal(false)
    setShowForm(false)

    if (confirmAction === 'launch') {
      const requestQueryParams = {
        client_secret: Constants.CLIENT_SECRET,
        crm_user_data: JSON.stringify({ user_id: id, name: userName })
      }

      const queryParams = _.pick(requestQueryParams, ApiHelper(client, 'BFS_LAUNCH').API_BODY)

      ApiHelper(client, 'BFS_LAUNCH')
        .API(client, queryParams)
        .then((response) => {
          showToastNotification({
            message: response.message || response.data.message || (response.status === Constants.CO_API.FAILED ? 'Failed' : 'Success'),
            isSuccess: response.status !== Constants.CO_API.FAILED
          })
        })
        .catch(console.error)
    }

    if (confirmAction === 'post') {
      const requestQueryParams = {
        crm_user_data: JSON.stringify({ user_id: id, name: userName }),
        client_secret: Constants.CLIENT_SECRET
      }

      const queryParams = _.pick(requestQueryParams, ApiHelper(client, 'POST_BFS').API_BODY)

      ApiHelper(client, 'POST_BFS')
        .API(client, queryParams)
        .then((response) => {
          showToastNotification({
            message: response.message || response.data.message || (response.status === Constants.CO_API.FAILED ? 'Failed' : 'Success'),
            isSuccess: response.status !== Constants.CO_API.FAILED
          })
        })
        .catch(console.error)
    }
  }

  const handlePreBFS = () => {
    const userId = state.userId

    if (!userId) {
      setState((prev) => ({
        ...prev,
        errors: { userId: 'Enter the userId' }
      }))

      setTimeout(() => {
        setState((prev) => ({ ...prev, errors: { userId: null } }))
      }, 5000)

      return
    }

    const requestQueryParams = {
      co_user_id: userId,
      cop_user_id: userId,
      client_secret: Constants.CLIENT_SECRET,
      crm_user_data: JSON.stringify({
        user_id: id,
        name: userName,
      })
    }

    let queryParams = _.pick(requestQueryParams, ApiHelper(client, 'PRE_BFS').API_BODY)

    ApiHelper(client, 'PRE_BFS').API(client, queryParams)
      .then((response) => {
        if (response.status === Constants.CO_API.FAILED) {
          showToastNotification({
            message: response.message || response.data.message || 'Failed',
            isSuccess: false,
          })
        } else {
          showToastNotification({
            message: response.data.message || 'success',
            isSuccess: true,
          })
        }
      })
      .catch((error) => {
        console.log(error)
      })
  }

  const handleReset = () => {
    setState((prev) => ({ ...prev, userId: '' }))
  }

  return (
    <div
      className="mis-wrapper"
      style={{ maxWidth: '600px' }}
    >
      <h5 className="heading-title">Black Friday Sales Tab</h5>
      <p className="heading-subtext">BFS Settings</p>
      <div className="container">
        <div className="d-flex justify-content-center gap-3 mt-3">
          <Button
            variant="outline-primary"
            onClick={showUserForm}
            style={{ flex: '1 1 25%' }}
          >
            Early Bird
          </Button>
          <Button
            variant="outline-primary"
            onClick={handleBfsLaunch}
            style={{ flex: '1 1 40%' }}
          >
            BFS Launch
          </Button>
          <Button
            variant="outline-primary"
            onClick={handlePostBFS}
            style={{ flex: '1 1 25%' }}
          >
            Post BFS
          </Button>
        </div>
        {showForm && (
          <div className="d-flex justify-content-center gap-3 mt-3">
            <Form>
              <div className="row">
                <Form.Group className="mt-4">
                  <Form.Label
                    htmlFor="payment-gateway-users__input"
                    className="mb-1"
                  >
                    User-ID:
                  </Form.Label>
                  <div className="col-md-12">
                    <div className="d-flex">
                      <Form.Control
                        type="text"
                        id="payment-gateway-users__input"
                        placeholder="Enter user-id"
                        value={state.userId}
                        onChange={handleUserIdChange}
                        isInvalid={!!state.errors.userId}
                      />
                      <Button
                        variant="outline-secondary"
                        className="filter-reset-btn ms-2"
                        onClick={handleReset}
                      >
                        Reset
                      </Button>
                    </div>
                    <Form.Control.Feedback type="invalid">
                      {state.errors.userId}
                    </Form.Control.Feedback>
                  </div>
                  <div className="payment-gateway-users__button">
                    <Button
                      variant="outline-success"
                      onClick={handlePreBFS}
                      disabled={state.userId.length === 0}
                    >
                      Pre BFS
                    </Button>
                  </div>
                </Form.Group>
              </div>
            </Form>
          </div>
        )}
      </div>
      {/* Confirmation Modal */}
      <ConfirmationModal
        show={showConfirmModal}
        onClose={() => setShowConfirmModal(false)}
        title={confirmAction === 'launch' ? 'Launch BFS' : 'Post BFS'}
        message={`Are you sure you want to ${confirmAction === 'launch' ? 'launch BFS' : 'run Post BFS'} now?`}
        onConfirm={handleConfirmAction}
        confirmText="Yes"
        cancelText="No"
      />
    </div>
  )
}

export default GlobalBfsSetting
